import { render } from "./JoinNowMemberStep03DOB.vue?vue&type=template&id=024e2ae0&scoped=true"
import script from "./JoinNowMemberStep03DOB.vue?vue&type=script&lang=js"
export * from "./JoinNowMemberStep03DOB.vue?vue&type=script&lang=js"

import "./JoinNowMemberStep03DOB.vue?vue&type=style&index=0&id=024e2ae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024e2ae0"]])

export default __exports__